/**
 * Utility function that outputs keys with truthy props
 * @param {object} obj any object
 * @returns {array} all of the keys of the obj that have truty props
 */
export default function getTruthyKeys (obj) {
  const keys = Object.keys(obj)
  let output = []
  keys.forEach(key => !!obj[key] && output.push(key))
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/getTruthyKeys.js